import $ from "jquery";

const ClearStorage = () => {
    const init = () => {
        if($('#we-are-sorry').length < 1) return;
        
        localStorage.clear();
    };

    init();
}

try {
    $(() => {
        ClearStorage();
    });
} catch (error) {
    console.error('clear sotrage', error);
}